import { Button, Checkbox, FormControlLabel } from '@mui/material';
import './Styles.css';

  export function EpCheckpoint({ value, checked, onChange, label, name, onClick, onClickdel}) {
    return (
      <div className='MyCheckboxWrapper'>
        <div className="MyCheckboxContent">
          <div className="FormControlLabel">
            <FormControlLabel
              value={value}
              control={<Checkbox checked={checked} onChange={onChange} color='primary'/>}
              label={label}
              name={name}
              labelPlacement="end"
            />
          </div>
            
            <div className='Buttons'>
              <div className="EditButton">
              <Button variant="outlined" onClick={onClick}>
                edit
              </Button>
              </div>
              <div className="DelButton">
              <Button variant="outlined" onClick={onClickdel}>
                delete
              </Button>
              </div>
            </div>
          </div>
      </div>
          
    
    );
  }
  
  
